import gqlTagGira from 'graphql-tag';

export const PROJECT_QUERY = gqlTagGira`
    query jira_deploymentsPage_getProject_Query($projectKey: String!) {
        project(projectKey: $projectKey) {
            id
            projectId
            key
            name
            simplified
            issueTypes {
                id
                name
                iconUrl
            }
        }
    }
`;
